<main class="main">
    <div class="main-wrapper">
      <section class="padding-first about1" id="about_us">
        <div class="container">

          <a [routerLink]="['/news']" [routerLinkActive]="['active']" class="more">
            <div class="icon-back">
              <span>Back</span>
            </div>
          </a>


          <div>
            <div class="bl-rows">
              <div class="text">
                <h2>Gennius XYZ Appoints Ana Velasquez as Managing Director for Latin America & Caribbean</h2>

                <span>By Gennius May 12, 2025</span>
              </div>
              <div class="img">
                <img src="./assets/img/gennius/bg-inside-notice17.png">
              </div>
            </div>
          </div>

          <div class="bl-center">
            <p><strong>Miami, USA </strong> &ndash; Gennius XYZ continues to accelerate its global expansion with the appointment of <strong>Ana Velasquez</strong> as <strong> Managing Director for Latin America & the Caribbean (LAC)</strong>. With over 15 years of experience in payments, technology, and strategic partnerships, Ana will lead the company's commercial strategy across the region, driving business growth and deepening relationships with banks, fintechs, and networks.
            </p>
            <p>"Ana’s deep understanding of the LAC market and her ability to lead transformative initiatives make her a key addition to our leadership team. Her appointment reinforces our commitment to scaling Gennius XYZ’s footprint in Latin America and building strategic partnerships that deliver long-term value," said <strong>Ruben Salazar Genovez</strong>, CEO of Gennius XYZ.
            </p>
            <p>Ana’s track record includes leading a 700-person global technology hub at <strong>Citi</strong>, negotiating some of the largest issuer deals in the region at <strong>Visa</strong>, and building impactful alliances across LAC at <strong>EPX</strong>. Her extensive experience in launching digital wallet programs and scaling tech operations positions her to deliver measurable growth and operational excellence across new markets and verticals.</p>
           
            <p>In her new role, Ana will oversee Gennius XYZ’s regional commercial agenda, aligning with the company’s mission to empower financial institutions and fintechs with modern loyalty and rewards solutions that increase engagement, retention, and revenue.
                Her leadership marks another strategic step forward in Gennius XYZ’s vision to redefine digital engagement globally through innovation, partnership, and a relentless focus on delivering results.</p>

            <p>We are excited to welcome Ana to the team and look forward to her leadership in shaping the future of financial engagement across Latin America.</p>
            <p>For more information about <strong>Gennius XYZ</strong>, please visit <a
                href="https://gennius.xyz/"><strong>www.gennius.xyz</strong></a>.</p>


          </div>

        </div>
      </section>


    </div>
</main>
<app-footer></app-footer>
